export default function Transformation() {
  const stats = [
    { number: '+6.2点', label: '内申点平均UP' },
    { number: '+8.5', label: '偏差値平均UP' },
    { number: '100%', label: '志望校合格率' },
    { number: '87%', label: '3ヶ月以内の成績向上' }
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 bg-white">
      <div className="max-w-lg md:max-w-4xl lg:max-w-6xl mx-auto">
        {/* ラベル */}
        <div className="mb-4">
          <span className="text-[#6B7280] text-xs font-medium tracking-wider uppercase">
            TRANSFORMATION
          </span>
        </div>

        {/* 見出し */}
        <h2 className="text-[28px] md:text-[40px] font-bold text-[#1A2B4A] mb-6 leading-tight">
          当塾に通うと、<br className="md:hidden" />こう変わります
        </h2>

        {/* メインコンテンツ：3カラムレイアウト */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 items-start">
          {/* 左：塾長の写真 */}
          <div className="md:col-span-1">
            <div className="rounded-2xl overflow-hidden shadow-lg sticky top-8">
              <img
                src="https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/ad20518c3a2816d56ad3093932ea9584.jpeg"
                alt="塾長からのメッセージ"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>

          {/* 中央：変化の説明 */}
          <div className="md:col-span-2">
            <div className="space-y-6 text-[#1A2B4A] text-base leading-relaxed mb-10">
              <div className="flex items-start gap-3">
                <span className="text-[#FF6B35] font-bold text-lg flex-shrink-0">▶</span>
                <p>
                  <strong className="font-bold">今のまま：</strong>何をすればいいか分からず、時間だけが過ぎていく。模試の結果を見るたびに不安が増す。
                </p>
              </div>
              
              <div className="flex items-start gap-3">
                <span className="text-[#FF6B35] font-bold text-lg flex-shrink-0">▶</span>
                <p>
                  <strong className="font-bold">通塾後：</strong>受験までの明確な学習計画ができ、毎日やるべきことが分かる。定期テストで点数が上がり、内申点も改善。模試の偏差値が右肩上がりになり、志望校合格への道筋が見えてくる。
                </p>
              </div>

              <div className="bg-[#FAF8F5] rounded-2xl p-6 mt-6">
                <p className="text-[#1A2B4A] font-bold text-center text-lg">
                  「無理かも…」から<br />
                  「合格できる！」へ
                </p>
              </div>
            </div>

            {/* 実績データ */}
            <div className="grid grid-cols-2 gap-4 lg:gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center bg-[#FAF8F5] rounded-2xl p-6 shadow-sm">
                  <div className="text-[#FF6B35] text-[40px] lg:text-[48px] font-black leading-none mb-2">
                    {stat.number}
                  </div>
                  <div className="text-[#1A2B4A] text-sm font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}